import { RESET_STATE } from 'store/global/actions';

import { FORM_TASK_ACTION_TYPE } from '../actions';

const initialState = {};

const formTaskReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FORM_TASK_ACTION_TYPE.SAVE_FORM_TASK_FIELDS_AS_DRAFT:
      return { ...payload };

    case FORM_TASK_ACTION_TYPE.RESET_FORM_TASK_FIELDS_DRAFT:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default formTaskReducer;
